import React from 'react';
import { ItemPath } from '../../../../order.schema';
import ResourceSection from '../../ItemTypes/Resource/ResourceSection';

interface FormResourceProps {
  itemPath: ItemPath;
}

export const FormResource: React.FC<FormResourceProps> = ({ itemPath }) => {
  return (
    <>
      <ResourceSection itemPath={itemPath} />
    </>
  );
};